"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { useClickAway, useKeyPressEvent } from "react-use";
import { createPortal } from "react-dom";
import type { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import SelectGroupSearchPanel from "./SelectGroupSearchPanel";
export default function SelectGroupModal(t0) {
  const $ = _c(8);
  const {
    onClose,
    onGroupSelect
  } = t0;
  const modalRef = useRef(null);
  const skipInitialOutsideClick = useRef(true);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const timeout = globalThis.setTimeout(() => {
        skipInitialOutsideClick.current = false;
      }, 0);
      return () => {
        globalThis.clearTimeout(timeout);
      };
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== onClose) {
    t3 = () => {
      if (skipInitialOutsideClick.current) {
        skipInitialOutsideClick.current = false;
        return;
      }
      onClose();
    };
    $[2] = onClose;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  useClickAway(modalRef, t3);
  useKeyPressEvent("Escape", onClose);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="tw-fixed tw-inset-0 tw-bg-gray-600 tw-bg-opacity-50" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== onClose || $[6] !== onGroupSelect) {
    t5 = createPortal(<div className="tw-relative tw-z-1000 tailwind-scope">{t4}<div className="tw-fixed tw-inset-0 tw-z-10 tw-overflow-y-auto"><div className="tw-flex tw-min-h-full tw-items-end tw-justify-center tw-text-center sm:tw-items-center tw-p-2 lg:tw-p-0"><div ref={modalRef} className="tw-w-full sm:tw-max-w-sm"><SelectGroupSearchPanel onClose={onClose} onGroupSelect={onGroupSelect} /></div></div></div></div>, document.body);
    $[5] = onClose;
    $[6] = onGroupSelect;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}